var path = 'src/app/forms/fields/consent-field.html';
var html = "<div class=checkbox> <label> <input frm-model consent-validator ng-model=model type=checkbox /> <span ng-transclude></span> </label> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/consent-field.html
 ** module id = 261
 ** module chunks = 0
 **/